import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect, useState } from 'react';
import CategoryApiService from '../../services/category.api.service';
import useAlert from '../Alert/useAlert';

export const CategorySelect = ({label, onChange, multiply = false}) => {
    const {showErrorAlert} = useAlert();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        CategoryApiService
            .list()
            .then(result => setCategories(result.items))
            .catch(err => showErrorAlert(err.response.data.message));
    }, []);

    return (
        <Autocomplete
            sx={{mb: 1, mt: 1}}
            options={categories}
            fullWidth
            size="small"
            multiple={multiply}
            onChange={(event, value) =>
                onChange(multiply ? value.map(category => category.id) : value.id)}
            getOptionLabel={category => category?.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={params => <TextField {...params} variant="standard" label={label} required/>}
        />
    );
};
